const STATUS_GROUPS = Object.freeze({
  pending: new Set([0, 1]),
  claimable: new Set([2]),
  success: new Set([8]),
  deducted: new Set([3, 4, 5, 6, 7]),
});

const STATUS_ALIASES = Object.freeze({
  pending: "pending",
  waiting: "pending",
  "pending-settlement": "pending",
  withdrawable: "claimable",
  claimable: "claimable",
  ready: "claimable",
  "ready-to-claim": "claimable",
  settled: "success",
  success: "success",
  claimed: "success",
  received: "success",
  voided: "deducted",
  "partial-refund": "deducted",
  refunded: "deducted",
  deducted: "deducted",
  "deduction-failed": "deducted",
});

export function normalizeRewardStatus(status) {
  const rawStatus = String(status ?? "").trim();
  const numericStatus = Number(rawStatus);
  if (rawStatus !== "" && Number.isInteger(numericStatus)) {
    for (const [group, codes] of Object.entries(STATUS_GROUPS)) {
      if (codes.has(numericStatus)) {
        return group;
      }
    }
  }

  const normalizedStatus = rawStatus
    .toLowerCase()
    .replace(/_/g, "-");
  return STATUS_ALIASES[normalizedStatus] || "unknown";
}

export function rewardStatusTextKey(status) {
  const statusGroup = normalizeRewardStatus(status);
  if (statusGroup === "pending") {
    return "invite.pendingSettlement";
  }
  if (statusGroup === "claimable") {
    return "invite.rewardReady";
  }
  if (statusGroup === "deducted") {
    return "invite.rewardDeducted";
  }
  return "invite.rewardSuccess";
}

export function rewardStatusClass(status, fallback = "success") {
  const statusGroup = normalizeRewardStatus(status);
  return `is-${statusGroup === "unknown" ? fallback : statusGroup}`;
}

export function rewardAmountClass(status) {
  return normalizeRewardStatus(status) === "deducted"
    ? "is-deducted"
    : "is-claimable";
}
